import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { api, apiError, showTest } from "@/lib/api";

export default function TestModeTab() {
  const [st, setSt] = useState(null);
  const [acc, setAcc] = useState(null);
  const [text, setText] = useState("");
  const [on, setOn] = useState(showTest.get());
  const load = () => {
    api.get("/test-mode/status").then(({ data }) => setSt(data));
    api.get("/test-mode/accounts").then(({ data }) => { setAcc(data); setText(data.emails.join("\n")); });
  };
  useEffect(load, []);
  const save = async () => {
    try { await api.put("/test-mode/accounts", { emails: text.split(/[\s,;]+/).filter(Boolean) }); toast.success("Test hesapları kaydedildi"); load(); } catch (e) { toast.error(apiError(e)); }
  };
  const toggle = (v) => { showTest.set(v); setOn(v); toast.message(v ? "Test kayıtları listelerde gösteriliyor" : "Test kayıtları gizlendi"); };
  return (
    <div className="panel p-4 space-y-4 max-w-3xl" data-testid="testmode-tab">
      <div className="text-[13px] text-slate-600">Test carisi: <b className="font-mono" data-testid="testmode-cari">{st?.test_cari ? `${st.test_cari.code} · ${st.test_cari.title}` : "—"}</b>
        {" "}· bu oturum test hesabı: <b data-testid="testmode-is-test-user">{st ? (st.is_test_user ? "Evet" : "Hayır") : "…"}</b></div>
      <label className="flex items-center gap-2 text-[13px]"><Switch checked={on} onCheckedChange={toggle} data-testid="testmode-show-toggle" />Test kayıtlarını göster (cari / sipariş / ithalat listeleri ve seçiciler)</label>
      <div>
        <div className="text-[12px] font-semibold text-slate-600 mb-1">Test hesapları (e-posta, satır başına bir)</div>
        <Textarea rows={8} value={text} onChange={(e) => setText(e.target.value)} className="font-mono text-[12px]" data-testid="testmode-emails" />
        <div className="text-[11px] text-slate-500 mt-1">Yalnız bu hesaplar TEST kayıtlarında işlem yapabilir. Bu hesaplar test dışı kullanıcıların fiş/fatura/dokümanlarını geri alamaz, iptal edemez, silemez.</div>
        {acc && <div className="text-[11px] text-slate-500 mt-1" data-testid="testmode-missing">{acc.accounts.filter((a) => !a.exists).map((a) => a.email).join(", ") || "Tüm hesaplar sistemde tanımlı"}</div>}
        <Button size="sm" className="mt-2" onClick={save} data-testid="testmode-save">Kaydet</Button>
      </div>
    </div>
  );
}
